// extracted by mini-css-extract-plugin
export default {"moduleContainer":"header_moduleContainer__k49Xp"};